export default __webpack_public_path__ + "static/media/website.b05c40cf.svg";